module.exports = __webpack_public_path__ + "img/accessory_item_04.0adef02d.svg";